<template>
  <div>
    <div class="wwi-step-form">
      <wwi-page-header
        :title="$t('pages.success.title')"
        :description="$t('pages.success.description')"
      />
      <form
        :action="logindata.url"
        method="post"
      >
        <input
          v-model="logindata.username"
          name="username"
          type="hidden"
        >
        <input
          v-model="logindata.password"
          name="password"
          type="hidden"
        >
        <button class="wwi-button">
          {{ $t('pages.success.login') }}
        </button>
        <i18n
          path="pages.success.confirmation"
          tag="p"
        >
          <a
            place="email"
            :href="mailto"
            target="_blank"
          >{{ email }}</a>
        </i18n>
      </form>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      logindata: {
        username: '',
        password: '',
        url: ''
      },
      email: ''
    }
  },
  computed: {
    mailto () {
      return 'mailto:' + this.email
    }
  },
  async mounted () {
    this.logindata = this.$store.getters['order/logindata']
    this.email = this.$store.getters['userdata/userdata'].email
  }
}
</script>
